module.exports = __webpack_public_path__ + "img/icon-rule.338f7cfe.svg";